export async function readAvailableDailyInsight({
  message,
  getCurrentStatusContextId,
  fetchRecommendation,
  isForContext,
}) {
  const signaledContextId = message?.statusContextId ? String(message.statusContextId) : null;
  if (!signaledContextId || String(getCurrentStatusContextId() || '') !== signaledContextId) return null;
  const recommendation = await fetchRecommendation();
  if (String(getCurrentStatusContextId() || '') !== signaledContextId) return null;
  return isForContext(recommendation, signaledContextId) ? recommendation : null;
}
